/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { apiList } from './apiList.service';
import { environment } from '../../environments/environment';

interface KuwaitSearchResponse {
  results?: any[];
  error?: any;
}

@Injectable({ providedIn: 'root' })
export class KuwaitFinderService {
  private token: string | null = null;
  private tokenExpiryMs: number | null = null;

  private readonly defaultExpirationMinutes = 1440;

  constructor(
    private http: HttpClient,
    private apiList: apiList
  ) {}

  /**
   * Search the Kuwait Finder service.
   *
   * Important default behaviour: `autoFetchToken = false` — search() will NOT generate a token automatically.
   * This ensures you don't hit generateToken on every keystroke. Call initToken() once in component instead.
   *
   * If you want search() to obtain a token automatically when missing/expired, call with autoFetchToken = true.
   */
  async search(
    searchText: string,
    coordinates: { lat: number; lng: number }
  ): Promise<any /* raw results */> {
    if (!searchText || !searchText.trim()) return { results: [] };
    const query = `search=${searchText}&lat=${coordinates.lat}&long=${coordinates.lng}`;
    const urlWithParams = `${environment.base_url}${this.apiList.kuwaitfinderSearch}?${query}`;
    try {
      const resp = await lastValueFrom(
        this.http.get<KuwaitSearchResponse>(urlWithParams)
      );
      return resp;
    } catch (err) {
      console.error('[KuwaitFinderService] search error', err);
      throw err;
    }
  }

  async searchWithCoord(coordinates: {
    lat: number;
    lng: number;
  }): Promise<any /* raw results */> {
    if (!coordinates.lat || !coordinates.lng) return { results: [] };
    const query = `search=${coordinates.lat},${coordinates.lng}&lat=${coordinates.lat}&long=${coordinates.lng}`;
    const urlWithParams = `${environment.base_url}${this.apiList.kuwaitfinderSearch}?${query}`;
    try {
      const resp = await lastValueFrom(
        this.http.get<KuwaitSearchResponse>(urlWithParams)
      );
      return resp;
    } catch (err) {
      console.error('[KuwaitFinderService] search error', err);
      throw err;
    }
  }
}
